import React from "react";
import { useNavigate } from "react-router-dom";

// Custom.
import Layout from "containers/Layout/Layout";
import { Form } from "@vocollege/components";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_MENU,
  UPDATE_MENU,
  CREATE_MENU,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import { regexPatterns } from "@vocollege/app";

const initialState = {
  name: "",
  title: "",
  description: "",
  links: [],
};

export default function MenuEdit() {
  const navigate = useNavigate();

  const handleRedirect = (state: any) => {
    navigate("/navigation/menus");
  };

  return (
    <Layout>
      <Form
        tabs={[
          {
            key: "content",
            label: I18n.get.misc.content,
            fields: [
              {
                name: "name",
                label: I18n.get.form.labels.name,
                type: "text",
                required: true,
                grid: {
                  xs: 12,
                },
                validation: {
                  required: true,
                  pattern: {
                    value: regexPatterns.cleanName,
                    message: I18n.get.acl.errors.invalidName,
                  },
                },
              },
              {
                name: "title",
                label: I18n.get.form.labels.title,
                type: "text",
                required: true,
                grid: {
                  xs: 12,
                },
                validation: {
                  required: true,
                },
              },
              {
                name: "description",
                label: I18n.get.form.labels.description,
                type: "text",
                grid: {
                  xs: 12,
                },
              },
            ],
          },
          {
            key: "links",
            label: I18n.get.menu.labels.links,
            fields: [
              {
                name: "links",
                label: I18n.get.menu.labels.links,
                type: "sortable_tree",
                grid: {
                  xs: 12,
                },
                params: {
                  dialog: {
                    types: ["page", "queue", "event"],
                  },
                },
              },
            ],
          },
        ]}
        labels={{
          loading: I18n.get.form.labels.loadingContent,
          create: I18n.get.form.labels.createMenu,
          created: I18n.get.menu.messages.menuSaved,
          updated: I18n.get.menu.messages.menuSaved,
          deleted: I18n.get.menu.messages.menuDeleted,
          fieldRequired: I18n.get.form.errors.required,
        }}
        operations={{
          category: "menu",
          get: GET_MENU,
          create: CREATE_MENU,
          update: UPDATE_MENU,
        }}
        // paths={{
        //   back: "/navigation/menus",
        // }}
        initialState={initialState}
        pageTitleField="title"
        primaryField="name"
        classes={{
          root: "vo-global__top-bottom-space",
          paper: "vo-global__content-with-toolbar",
          toolbar: "vo-global__content-toolbar",
        }}
        onComplete={handleRedirect}
        onCancel={handleRedirect}
      />
    </Layout>
  );
}
